module.exports = __webpack_public_path__ + "static/media/companyphoto.09fe8c04.jpg";